import { UserRetailAccount } from '@shared/types';

export const PORTFOLIO_SELECTED_ACCOUNT_KEY = 'nq.portfolio.selectedAccountId';

export function getStoredPortfolioAccountId(): string | null {
  return localStorage.getItem(PORTFOLIO_SELECTED_ACCOUNT_KEY);
}

export function setStoredPortfolioAccountId(id: string) {
  localStorage.setItem(PORTFOLIO_SELECTED_ACCOUNT_KEY, id);
}

export function pickDefaultAccountId(accounts: UserRetailAccount[]): string | null {
  if (accounts.length === 0) return null;

  const stored = getStoredPortfolioAccountId();
  if (stored && accounts.some((a) => a.id === stored)) return stored;

  const active = accounts.find((a) => a.active);
  if (active) return active.id;

  return accounts[0].id;
}
